import i18n from '@/i18n';

const dataMaster = [
    {
        name: 'パルディア社員',
        key: 'employee',
        rowspan: 1,
        childMain: '権限・チーム関連',
        keyMain: 'department',
        child: []
    },
    {
        name: 'FAQ',
        key: 'faq_master',
        rowspan: 1,
        childMain: 'FAQシート項目',
        keyMain: 'sheets',
        child: []
    },
    {
        name: 'キャンペーン',
        key: 'campaign',
        rowspan: 36,
        childMain: '',
        keyMain: 'status',
        child: [
            {
                name: i18n.t('pageCampaign.targetProductCategoryOpen'),
                key: 'product_target'
            },
            {
                name: '当選数',
                key: 'number_prizes'
            },
            {
                name: 'SNS応募条件',
                key: 'conditions_applying_sns'
            },
            {
                name: 'タレント・キャラクター',
                key: 'talent_character'
            },
            {
                name: '告知方法',
                key: 'announcement_method'
            },
            {
                name: 'エンドクライエントカテゴリ',
                key: 'category_customer'
            },
            {
                name: 'メーカー',
                key: 'maker'
            },
            {
                name: '流通',
                key: 'distribution'
            },
            {
                name: '食品',
                key: 'food'
            },
            {
                name: '食料',
                key: 'drink'
            },
            {
                name: '医薬品',
                key: 'pharmaceuticals'
            },
            {
                name: '化粧品',
                key: 'cosmetics'
            },
            {
                name: 'トイレタリー・日用品',
                key: 'toiletries_daily_necessities'
            },
            {
                name: '家電製品',
                key: 'home_appliances'
            },
            {
                name: 'AV・コンピューター及び周辺機器',
                key: 'AVComputers_and_peripherals'
            },
            {
                name: '通信サービス',
                key: 'communication_service'
            },
            {
                name: '衣料･ファッション･装飾品',
                key: 'clothing_fashion_and_accessories'
            },
            {
                name: 'おもちゃ',
                key: 'toy'
            },
            {
                name: '出版･趣味･娯楽品',
                key: 'publishing_hobbies_entertainment_items'
            },
            {
                name: '家庭用品',
                key: 'household_goods'
            },
            {
                name: 'ペット用品',
                key: 'pet_supplies'
            },
            {
                name: '案件内容',
                key: 'project_details'
            },
            {
                name: 'ツール',
                key: 'tool'
            },
            {
                name: '購買条件',
                key: 'purchase_conditions_1'
            },
            {
                name: '対応指示',
                key: 'prize_less_status'
            },
            {
                name: 'お問い合わせ',
                key: 'inquiry'
            },
            {
                name: '種別',
                key: 'type'
            },
            {
                name: '賞品カテゴリ',
                key: 'gift_category'
            },
            {
                name: '賞品あまりステータス',
                key: 'prize.remain_status'
            },
            {
                name: 'デジタルギフト',
                key: 'prize.digital_gift'
            }
        ]
    }
];

const nameMaster = {
    'employee.team': 'チームマスタ',
    'employee.group': 'グループマスタ'
};

const keyMaster = {
    'employee.team': 'employee.team',
    'employee.department': 'employee.department',
    'foreign_partner.type': 'foreign_partner.type',
    'faq_master.category': 'faq_master.category',
    'faq_master.sheets': 'faq_master.sheets',
    'prize.prize_less_status': 'prize.prize_less_status',
    'campaign.type': 'campaign.type',
    'campaign.status': 'campaign.status',
    'campaign.conditions_applying_admission': 'campaign.conditions_applying_admission',
    'campaign.project_details': 'campaign.project_details',
    'campaign.conditions_applying_sns': 'campaign.conditions_applying_sns',
    'campaign.product_target': 'campaign.product_target',
    'campaign.purchase_condition': 'campaign.purchase_condition',
    'campaign.purchase_conditions_2': 'campaign.purchase_conditions_2',
    'campaign.tool': 'campaign.tool',
    'campaign.information_ip': 'campaign.information_ip',
    'prize.corresponding_status': 'prize.corresponding_status',
    'prize.storage_warehouse': 'prize.storage_warehouse',
    'campaign.sponsor_information': 'campaign.sponsor_information',
    'campaign.advertising': 'campaign.advertising',
    'campaign.social_platform': 'campaign.social_platform',
    'client.agency_type': 'client.agency_type',
    'client.maker_type': 'client.maker_type',
    'client.circulate_type': 'client.circulate_type'
};

const ALL_BLOCK_TYPE = {
    BLOCK_INPUT: 'input',
    BLOCK_RADIO: 'radio',
    BLOCK_TEXTAREA: 'textarea',
    BLOCK_CHECKBOX: 'checkbox',
    BLOCK_SELECT: 'select_box',
    BLOCK_DISPLAY_1: 'display_block_1',
    BLOCK_DISPLAY_2: 'display_block_2',
    BLOCK_UPLOAD_FILE: 'upload_file',
    BLOCK_DATE: 'date',
    BLOCK_FULL_NAME: 'full_name',
    BLOCK_POSTAL_CODE: 'postal_code',
    BLOCK_SELECT_BOX_PROVINCE: 'select_box_province',
    BLOCK_PHONE_NUMBER: 'phone_number',
    BLOCK_SEAT_AVAILABILITY: 'seat_availability_box',
    BLOCK_KEYWORD_BOX: 'keyword_box',
    BLOCK_PARAMETER_ACQUISITION: 'parameter_acquisition',
    BLOCK_POSTCODE_AND_PROVINCE: 'postcode_and_province',
    // block default
    BLOCK_INFO_FULL_NAME: 'info_full_name',
    BLOCK_PERSONAL_INFORMATION_BLOCK: 'personal_information_block',
    BLOCK_EMAIL_ADDRESS_SINGLE: 'email_address_single',
    BLOCK_EMAIL_ADDRESS_CONFIRMATION: 'email_address_confirmation',
    BLOCK_AGE_AND_GENDER: 'age_and_gender',
    BLOCK_GENDER: 'gender',
    BLOCK_X_ACCOUNT: 'x_account',
    BLOCK_INSTAGRAM_ACCOUNT: 'instagram_account',
    BLOCK_DEPOSIT: 'deposit_block'
};

const BLOCK_COMMON = [
    {
        id: 1,
        name: 'ラジオボタン(単一選択)',
        icon: 'mdi mdi-radiobox-marked',
        type: ALL_BLOCK_TYPE.BLOCK_RADIO
    },
    {
        id: 2,
        name: 'セレクトボックス(単一選択)',
        icon: 'mdi mdi-select-place',
        type: ALL_BLOCK_TYPE.BLOCK_SELECT
    },
    {
        id: 3,
        name: 'チェックボックス(複数選択)',
        icon: 'ri-checkbox-line',
        type: ALL_BLOCK_TYPE.BLOCK_CHECKBOX
    },
    {
        id: 4,
        name: 'テキスト(単一行)',
        icon: 'mdi mdi-format-text',
        type: ALL_BLOCK_TYPE.BLOCK_INPUT
    },
    {
        id: 5,
        name: 'テキスト(複数行)',
        icon: 'mdi mdi-text-box-multiple-outline',
        type: ALL_BLOCK_TYPE.BLOCK_TEXTAREA
    },
    {
        id: 7,
        name: '表示用ブロック1',
        icon: 'ri-file-list-line',
        type: ALL_BLOCK_TYPE.BLOCK_DISPLAY_1
    },
    {
        id: 8,
        name: '表示用ブロック2',
        icon: 'mdi mdi-timeline-text-outline',
        type: ALL_BLOCK_TYPE.BLOCK_DISPLAY_2
    },
    {
        id: 9,
        name: 'ファイルアップロード',
        icon: 'ri-folder-upload-line',
        type: ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE
    },
    {
        id: 10,
        name: '日付',
        icon: 'ri-calendar-2-line',
        type: ALL_BLOCK_TYPE.BLOCK_DATE
    },
    {
        id: 11,
        name: '氏名',
        icon: 'ri-user-line',
        type: ALL_BLOCK_TYPE.BLOCK_FULL_NAME
    },
    {
        id: 12,
        name: '郵便番号',
        icon: 'mdi mdi-map-marker-radius-outline',
        type: ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE
    },
    {
        id: 13,
        name: '都道府県',
        icon: 'ri-building-line',
        type: ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE
    },
    {
        id: 14,
        name: '電話番号',
        icon: 'ri-phone-line',
        type: ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER
    },
    {
        id: 15,
        name: '残席管理ボックス',
        icon: 'mdi mdi-seat',
        type: ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY
    },
    {
        id: 16,
        name: 'キーワードボックス',
        icon: 'mdi mdi-folder-key-outline',
        type: ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX
    },
    {
        id: 17,
        name: 'パラメータ取得',
        icon: 'mdi mdi-playlist-star',
        type: ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION
    }
];
const DEFAULT_BLOCK_COMMON = [
    {
        id: 1,
        name: '名前ブロック',
        icon: '',
        type: ALL_BLOCK_TYPE.BLOCK_INFO_FULL_NAME
    },
    {
        id: 2,
        name: '個人情報ブロック（氏名＆住所＆電話番号＆メールアドレス）',
        icon: '',
        type: ALL_BLOCK_TYPE.BLOCK_PERSONAL_INFORMATION_BLOCK
    },
    {
        id: 3,
        name: 'メールアドレス（単一）',
        icon: '',
        type: ALL_BLOCK_TYPE.BLOCK_EMAIL_ADDRESS_SINGLE
    },
    {
        id: 4,
        name: 'メールアドレス（確認ブロックあり）',
        icon: '',
        type: ALL_BLOCK_TYPE.BLOCK_EMAIL_ADDRESS_CONFIRMATION
    },
    {
        id: 5,
        name: '年齢・性別',
        icon: '',
        type: ALL_BLOCK_TYPE.BLOCK_AGE_AND_GENDER
    },
    {
        id: 7,
        name: '性別',
        icon: '',
        type: ALL_BLOCK_TYPE.BLOCK_GENDER
    },
    {
        id: 8,
        name: 'Xアカウント',
        icon: '',
        type: ALL_BLOCK_TYPE.BLOCK_X_ACCOUNT
    },
    {
        id: 9,
        name: 'Instagramアカウント',
        icon: '',
        type: ALL_BLOCK_TYPE.BLOCK_INSTAGRAM_ACCOUNT
    },
    {
        id: 10,
        name: '入金項目ブロック',
        icon: '',
        type: ALL_BLOCK_TYPE.BLOCK_DEPOSIT
    },
    {
        id: 11,
        name: '住所ブロック一括作成',
        icon: '',
        type: ALL_BLOCK_TYPE.BLOCK_POSTCODE_AND_PROVINCE
    }
];

//2 電話, 5 メール,8 DM, 13 その他
// 9 Twitter, 10 Instagram, 11 Tiktok, 12 LINE
const LIST_INQUIRY_FIT = [2, 5, 8, 13];
const LIST_CHILD_DM = [9, 10, 11, 12];

const PHONE_SETTING_EMPLOYEE = [
    {
        id: 1,
        label: 'テスト・ガイダンス担当'
    },
    {
        id: 2,
        label: '電話工事担当'
    },
    {
        id: 3,
        label: '振り分け担当'
    }
];

const ARRTYPEFIXED = [
    { id: 1, value: '発送' },
    { id: 2, value: '運営事務局' },
    { id: 3, value: '電話工事' },
    { id: 4, value: 'デザイン' },
    { id: 5, value: '印刷' },
    { id: 6, value: 'SNS投稿' }
];

const ID_ROLE_FIXED = {
    ADMIN: 1,
    SALE_INSTRUCTOR: 2,
    PART_TIME: 4,
    EXTERNAL_PARTNER: 5,
    INQUIRY_PARTNER: 6,
    OFFICE_PARTNER: 7,
    SHIPPING_PARTNER: 8,
    OFFICE_SHIPPING_PARTNER: 9
};

const NAMEROLEFIXED = [
    {
        id: ID_ROLE_FIXED.ADMIN,
        text: i18n.t('administrator')
    },
    {
        id: ID_ROLE_FIXED.SALE_INSTRUCTOR,
        text: i18n.t('sale_instructor')
    },
    {
        id: ID_ROLE_FIXED.PART_TIME,
        text: 'アルバイト'
    },
    {
        id: ID_ROLE_FIXED.EXTERNAL_PARTNER,
        text: '外部パートナー'
    },
    {
        id: ID_ROLE_FIXED.INQUIRY_PARTNER,
        text: 'お問い合わせパートナー'
    },
    {
        id: ID_ROLE_FIXED.OFFICE_PARTNER,
        text: '事務局パートナー'
    },
    {
        id: ID_ROLE_FIXED.SHIPPING_PARTNER,
        text: '発送パートナー'
    },
    {
        id: ID_ROLE_FIXED.OFFICE_SHIPPING_PARTNER,
        text: '事務局発送パートナー'
    }
];

const extensionToMimeType = {
    // Images
    jpeg: 'image/jpeg',
    jpg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    bmp: 'image/bmp',
    webp: 'image/webp',
    svg: 'image/svg+xml',
    ico: 'image/x-icon',
    heic: 'image/heic',
    heif: 'image/heif',

    // Documents
    pdf: 'application/pdf',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    txt: 'text/plain',
    rtf: 'application/rtf',
    csv: 'text/csv',

    // Archives
    zip: 'application/zip',
    rar: 'application/x-rar-compressed',
    '7z': 'application/x-7z-compressed',
    tar: 'application/x-tar',
    gz: 'application/gzip',

    // Audio
    mp3: 'audio/mpeg',
    wav: 'audio/wav',
    ogg: 'audio/ogg',
    m4a: 'audio/mp4',

    // Video
    mp4: 'video/mp4',
    avi: 'video/x-msvideo',
    mov: 'video/quicktime',
    wmv: 'video/x-ms-wmv',
    flv: 'video/x-flv',
    mkv: 'video/x-matroska',

    // Others
    json: 'application/json',
    xml: 'application/xml',
    html: 'text/html',
    css: 'text/css',
    js: 'text/javascript'
};

export {
    dataMaster,
    nameMaster,
    keyMaster,
    extensionToMimeType,
    BLOCK_COMMON,
    DEFAULT_BLOCK_COMMON,
    LIST_INQUIRY_FIT,
    LIST_CHILD_DM,
    PHONE_SETTING_EMPLOYEE,
    ARRTYPEFIXED,
    NAMEROLEFIXED,
    ALL_BLOCK_TYPE,
    ID_ROLE_FIXED
};
